import React from 'react';
import { getImageByPaymentMethod } from '../../../assets/themes/images';
import Pricing from './Pricing';

const getTextColor = (responseCode) => {
  return responseCode === 'SUCCESS' ? 'text-green-600' : 'text-red-600';
};

const InfoPayment = React.memo(({ headerText, pricing, paymentDetails }) => {
  const PaymentSuccess = () => (
    <div className="flex flex-row items-center py-2">
      <div className="flex flex-col items-center mr-4 w-20">
        <img src={getImageByPaymentMethod('SUCCESS')} alt="Success" className="h-8 w-8" />
        <div className="mt-1">
          <p className={`text-sm font-semibold ${getTextColor(paymentDetails?.responseCode)}`}>
            {paymentDetails?.responseCode}
          </p>
        </div>
      </div>
      <div className="flex flex-row justify-between w-full">
        <div>
          <p className="text-lg font-bold">₹ {paymentDetails?.amount}</p>
          <p className="text-[10px]">UTR: {paymentDetails?.paymentInstrument?.utr}</p>
          <p className="text-[10px]">Txn Id: {paymentDetails?.transactionId}</p>
        </div>
        <div className="flex flex-col items-center">
          <img src={getImageByPaymentMethod(paymentDetails?.paymentInstrument?.type)} alt="Payment Method" className="h-10 w-14" />
          <p className="text-xs">Mode: {paymentDetails?.paymentInstrument?.type}</p>
        </div>
      </div>
    </div>
  );

  const PaymentFailure = () => (
    <div className="flex flex-row items-center py-2">
      <div className="flex flex-col items-center mr-4 w-20">
        <img src={getImageByPaymentMethod('FAILURE')} alt="Failure" className="h-8 w-8" />
        <div className="mt-1">
          <p className="text-sm font-semibold text-red-600">Unpaid</p>
        </div>
      </div>
      <div>
        <p className="text-lg font-bold">₹ {pricing?.finalAmount2?.value}</p>
      </div>
    </div>
  );

  return (
    <div className="p-4 bg-white rounded-lg shadow-md">
      <div className="mb-3 border-b pb-2">
        <h2 className="text-lg font-semibold">Payment</h2>
      </div>
      <div>
        {paymentDetails?.state === 'COMPLETED' && (paymentDetails?.responseCode === 'SUCCESS'||paymentDetails?.responseCode === 'PAYMENT_SUCCESS') ? (
          <PaymentSuccess />
        ) : (
          <PaymentFailure />
        )}
      </div>

      {/* Pricing section below the card */}
      <div className="mt-4">
        <Pricing pricing={pricing} />
      </div>
    </div>
  );
});

export default InfoPayment;
